import React, { useState } from 'react';
import { PDFDownloadLink, PDFViewer } from '@react-pdf/renderer';
import AuditoriaDocument from './AuditoriaDocument';
import { IconButton, Modal, Box } from '@mui/material';
import { Close } from '@mui/icons-material';

const AuditoriaPDF = ({ auditoria }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  
  const handleClose = () => setOpen(false);

  if (!auditoria) {
    return null;
  }

  return (
    <>
      <button 
        className="text-xs px-2 py-1 bg-sky-100 text-sky-700 rounded hover:bg-sky-200 transition-colors"
        title="Ver detalles de la auditoría"
        onClick={handleOpen}
      >
        Ver
      </button>
      
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '80%',
          height: '80%',
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          borderRadius: 2,        }}>
          <>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
              <PDFDownloadLink
                document={<AuditoriaDocument auditoria={auditoria} />}
                fileName={`auditoria-calidad-${auditoria.id}.pdf`}
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 transition-colors"
              >
                {({ blob, url, loading, error }) =>
                  loading ? 'Preparando documento...' : 'Descargar PDF'
                }
              </PDFDownloadLink>
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            </Box>
            <PDFViewer width="100%" height="90%">
              <AuditoriaDocument auditoria={auditoria} />
            </PDFViewer>
          </>
        </Box>
      </Modal>
    </>
  );
};

export default AuditoriaPDF;
